module.exports = __webpack_public_path__ + "img/order.3c5a2e4b.svg";